module.exports = __webpack_public_path__ + "static/media/IMG_0877.3e65e744.jpg";